import Vue from "vue";
import Vuetify from "vuetify/lib";
import { Ripple } from "vuetify/lib/directives";
import i18n from "./i18n";

Vue.use(Vuetify, {
	directives: {
		Ripple,
	},
});

export default new Vuetify({
	lang: {
		t: (key, ...params) => i18n.t(key, params),
	},
	theme: {
		themes: {
			light: {
				accent: "#EFBB20", // rgba(239, 187, 32)
				highlight: "#AA6200", // for highlighting text on white background
			},
		},
	},
});
